// app lib
import isProduction from '../../app/lib/isProduction.lib.app';

// Session Replay: This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
const REPLAYS_SESSION_SAMPLE_RATE = () => (isProduction() ? 0.1 : 1.0);

export default REPLAYS_SESSION_SAMPLE_RATE;
